import { render, staticRenderFns } from "./adopt.vue?vue&type=template&id=5092a633&scoped=true"
import script from "./adopt.vue?vue&type=script&lang=js"
export * from "./adopt.vue?vue&type=script&lang=js"
import style0 from "./adopt.vue?vue&type=style&index=0&id=5092a633&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5092a633",
  null
  
)

export default component.exports